import React, { useState } from 'react';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import PageFooter from './components/pageFooter';
import './NailCommissionPage.css';
import { API_URL } from '../config';
import nail3a from '../images/nails/nail3a.jpg';
import nail3b from '../images/nails/nail3b.jpg';
import nail4a from '../images/nails/nail4a.jpg';
import nail4b from '../images/nails/nail4b.JPG';


const TIERS = [
  { id: 'tier1', label: 'tier 1', price: 30, desc: 'nail set no. 3', design: { id: 'nail-3', name: 'nail set no. 3', desc: 'medium almond', images: [nail3b, nail3a] } },
  { id: 'tier2', label: 'tier 2', price: 40, desc: 'nail set no. 4', design: { id: 'nail-4', name: 'nail set no. 4', desc: 'short round', images: [nail4b, nail4a] } },
];

const SHAPES = ['Round', 'Almond', 'Stiletto'];
const LENGTHS = ['Extra Short', 'Short', 'Medium'];

export const NailMailPage = () => {
  const [shape, setShape] = useState('');
  const [length, setLength] = useState('');
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [notes, setNotes] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [sizingOpen, setSizingOpen] = useState(false);
  const [nailSizes, setNailSizes] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [designPrefs, setDesignPrefs] = useState('');
  const [tier, setTier] = useState('');
  const [agree, setAgree] = useState(false);

  const selectedTier = TIERS.find(t => t.id === tier);
  const canSubmit = tier && shape && length && name && address && city && state && zip && contactInfo && nailSizes && agree;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/nailmail/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          plan: selectedTier?.label,
          shape, length, name, email: contactInfo,
          shipping: { fullName: name, address1: address, city, state, zip },
          nailSizes, contactInfo, designPrefs, notes,
          tier, designChoice: selectedTier?.design.id,
        }),
      });
      const data = await res.json();
      if (data.success) setSubmitted(true);
      else setError(data.error || 'something went wrong');
    } catch {
      setError('could not connect to server');
    }
  };

  if (submitted) {
    return (
      <PageLayout><PageContainer><PageBody>
        <NavigationHeader />
        <PageText>
          <div className="commission-container">
            <h2 className="commission-title">\u2727 you're subscribed \u2727</h2>
            <p className="commission-note" style={{ textAlign: 'center' }}>
              thank you, {name}! your first nail mail box will ship soon.
            </p>
            <p className="commission-note" style={{ textAlign: 'center' }}>
              a confirmation will be sent to {contactInfo}
            </p>
          </div>
        </PageText>
        <PageFooter />
      </PageBody></PageContainer></PageLayout>
    );
  }

  return (
    <PageLayout>
      <PageContainer>
        <PageBody>
          <NavigationHeader />
          <PageText>
            <div className="commission-container">
              <h2 className="commission-title">\u2727 nail mail \u2727</h2>
              <div className="commission-info">
                <p>a monthly subscription box delivered to your door</p>
                <ul className="commission-list">
                  <li>\u2727 1 set of handmade press-on nails</li>
                  <li>\u2727 1 exclusive sticker</li>
                  <li>\u2727 a prep kit with every first box</li>
                  <li>\u2727 made with Apr\u00e9s gel-x tips</li>
                </ul>
                <p className="commission-note">tier 1 \u00b7 $30/mo, nail set no. 3 (medium almond)</p>
                <p className="commission-note">tier 2 \u00b7 $40/mo, nail set no. 4 (short round)</p>
                <p className="commission-note">boxes ship on the 1st of each month.</p>
                <p className="commission-note">free shipping on every box.</p>
                <p className="commission-note">cancel anytime, no commitment.</p>
              </div>

              <div className="nailmail-set-preview">
                <p className="nailmail-set-month">\u2727 april set \u2727</p>
                <div className="nailmail-design-picker">
                  {TIERS.map((t) => (
                    <button
                      type="button"
                      key={t.id}
                      className={`nailmail-design-option ${tier === t.id ? 'selected' : ''}`}
                      onClick={() => setTier(t.id)}
                    >
                      <img src={t.design.images[0]} alt={t.design.name} className="nailmail-design-img" style={{ width: '100%' }} />
                      <p className="nailmail-set-name">{t.label} \u00b7 ${t.price}/mo</p>
                      <p className="nailmail-set-desc">shown in {t.design.desc}</p>
                    </button>
                  ))}
                </div>
                {!tier && <p className="form-hint" style={{ marginTop: 8 }}>please select a tier to continue</p>}
              </div>

              <form className="commission-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">shape</label>
                  <div className="form-radios">
                    {SHAPES.map((s) => (
                      <button type="button" key={s} className={`form-radio ${shape === s ? 'selected' : ''}`} onClick={() => { setShape(s); if (length === 'Extra Short' && s !== 'Round') setLength(''); }}>{s}</button>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">length</label>
                  <div className="form-radios">
                    {LENGTHS.filter((l) => l !== 'Extra Short' || shape === 'Round').map((l) => (
                      <button type="button" key={l} className={`form-radio ${length === l ? 'selected' : ''}`} onClick={() => setLength(l)}>{l}</button>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">nail sizes *</label>
                  <p className="form-hint">measure the width of each nail in mm. standard sizes:</p>
                  <div className="sizing-guide">
                    <button type="button" className="sizing-guide-toggle" onClick={() => setSizingOpen(!sizingOpen)}>
                      {sizingOpen ? '\u25be' : '\u25b8'} how to find your size
                    </button>
                    {sizingOpen && (
                      <div className="sizing-guide-content">
                        <p>Measure the widest part of each nail bed in millimeters:</p>
                        <table className="sizing-table">
                          <thead><tr><th>Size</th><th>Thumb</th><th>Index</th><th>Middle</th><th>Ring</th><th>Pinky</th></tr></thead>
                          <tbody>
                            <tr><td>XS</td><td>12mm</td><td>10mm</td><td>10mm</td><td>9mm</td><td>7mm</td></tr>
                            <tr><td>S</td><td>14mm</td><td>12mm</td><td>12mm</td><td>11mm</td><td>9mm</td></tr>
                            <tr><td>M</td><td>16mm</td><td>14mm</td><td>13mm</td><td>12mm</td><td>10mm</td></tr>
                            <tr><td>L</td><td>18mm</td><td>15mm</td><td>14mm</td><td>13mm</td><td>11mm</td></tr>
                            <tr><td>XL</td><td>20mm</td><td>17mm</td><td>16mm</td><td>15mm</td><td>13mm</td></tr>
                          </tbody>
                        </table>
                        <p className="sizing-tip">tip: if you're between sizes, size up. if you know your gel-x tip sizes, include them in the notes.</p>
                      </div>
                    )}
                  </div>
                  <textarea className="form-textarea" placeholder="e.g. L: 11, 12, 13, 14, 15; R: 11, 12, 13, 14, 15" value={nailSizes} onChange={(e) => setNailSizes(e.target.value)} rows={2} />
                </div>

                <div className="form-group">
                  <label className="form-label">contact email *</label>
                  <input
                    className="form-input"
                    type="email"
                    placeholder="your email"
                    value={contactInfo}
                    onChange={(e) => setContactInfo(e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">name *</label>
                  <input className="form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="your name" />
                </div>

                <div className="form-group">
                  <label className="form-label">shipping address</label>
                  <input className="form-input" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="street address" />
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input className="form-input" value={city} onChange={(e) => setCity(e.target.value)} placeholder="city" style={{ flex: 2 }} />
                    <input className="form-input" value={state} onChange={(e) => setState(e.target.value)} placeholder="state" style={{ flex: 1 }} />
                    <input className="form-input" value={zip} onChange={(e) => setZip(e.target.value)} placeholder="zip" style={{ flex: 1 }} />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">design preferences (optional)</label>
                  <textarea
                    className="form-textarea"
                    placeholder="any colors, themes, or styles you love or want to avoid"
                    value={designPrefs}
                    onChange={(e) => setDesignPrefs(e.target.value)}
                    rows={2}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">notes (optional)</label>
                  <textarea
                    className="form-textarea"
                    placeholder="anything else joy should know"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    rows={2}
                  />
                </div>

                <div className="form-group">
                  <label className="form-checkbox">
                    <input
                      type="checkbox"
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                    />
                    <span>i understand this is a monthly subscription and agree to the terms *</span>
                  </label>
                </div>

                {error && <p className="commission-note" style={{ color: '#c0392b' }}>{error}</p>}

                <button type="submit" className="commission-btn commission-submit-btn" disabled={!canSubmit}>
                  {tier ? `subscribe \u00b7 $${TIERS.find(t => t.id === tier)?.price}/mo` : 'select a tier'}
                </button>
              </form>
            </div>
          </PageText>
          <PageFooter />
        </PageBody>
      </PageContainer>
    </PageLayout>
  );
};
